import React from "react";
import { useLocation, Navigate, Outlet } from "react-router-dom";

import { getUserRoles, getAuthToken } from "../helpers/constants";

interface ProtectedRouteProps {
  allowedRoles: any;
}

const Protected: React.FC<ProtectedRouteProps> = ({ allowedRoles }) => {
  const location = useLocation();
  let roles = getUserRoles();
  let hasAuthToken = getAuthToken();

  return !hasAuthToken ? (
    <Navigate to="/" state={{ from: location }} replace />
  ) : allowedRoles.find((role: any) => roles.includes(role)) ? (
    <Outlet />
  ) : (
    <Navigate to="/not-authorized" state={{ from: location }} replace />
  );
};

export default Protected;
